import { useEffect, useRef } from 'react';
import { observer } from '../../../../../../constants';
import { Message } from '../Message/Message';
import styles from './Messages.module.scss';
import { NoContent } from 'components';
import { selectFeedMessages, selectFeedMessagesFilter, selectFeedMessagesInfo } from 'store/dashboard/selectors';
import { dashboardActions } from 'store/dashboard/slice';
import { useDispatch, useSelector } from 'store/utils';

export const Messages = () => {
  const dispatch = useDispatch();

  const feed = useSelector(selectFeedMessages);
  const feedInfo = useSelector(selectFeedMessagesInfo);
  const feedFilter = useSelector(selectFeedMessagesFilter);

  const ref = useRef<HTMLDivElement | null>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        const fetchNextPage = entries[0].isIntersecting && feedInfo && !feedInfo.last && ref.current;
        if (fetchNextPage) {
          dispatch(
            dashboardActions.setFeedFilter({
              page: feedFilter.page + 1,
            }),
          );
          ref.current && observerRef?.current?.unobserve(ref.current);
        }
      },
      {
        rootMargin: observer.rootMargin,
      },
    );

    if (observerRef.current && ref.current) {
      observerRef.current.observe(ref.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [dispatch, feed]);

  return feed.length ? (
    <div className={styles.container}>
      {feed.map((feedItem, index) => (
        <Message key={feedItem.message.id} feedItem={feedItem} ref={index === feed.length - 1 ? ref : null} />
      ))}
    </div>
  ) : (
    <NoContent pageKey="dashboardFeed" className={styles.noContent} />
  );
};
